import React from "react";
import { useState, useEffect } from "react";
import { Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import FileUpload from "../../Constant/fileupload";
import { createBrandApi, editBrandApi } from "../../../services/VehicleService";
const AddBrandModal = ({ visible, onClose, onAfterSubmit, data = null }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    logo: null,
    is_bike: false,
  });
  const [error, setError] = useState({});
  useEffect(() => {
    if (visible) {
      handleReset();
    }
  }, [visible]);

  const handleReset = () => {
    if (data) {
      setForm({
        name: data?.name || "",
        logo: data?.logo || null,
        is_bike: data?.is_bike || false,
      });
    } else {
      setForm({
        name: "",
        logo: null,
        is_bike: false,
      });
    }

    setError({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (value && error[name]) {
      setError({ ...error, [name]: "" });
    }
  };

  const createBrand = (data) => {
    setLoading(true);
    createBrandApi(data)
      .then((res) => {
        toast.success("Brand Created Successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const editBrand = (payload) => {
    setLoading(true);
    editBrandApi(data?.id || "", payload)
      .then((res) => {
        toast.success("Brand Update Successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    let error = {};
    if (!form?.name) {
      error.name = "Name Required";
    }

    setError(error);
    if (Object.entries(error).length == 0) {
      const formData = new FormData();

      formData.append("name", form.name || "");
      formData.append("is_bike", form.is_bike);

      if (form.logo instanceof File) {
        formData.append("logo", form.logo);
      }

      if (data) {
        editBrand(formData);
      } else {
        createBrand(formData);
      }
    }
  };
  return (
    <div>
      <Modal show={visible} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{data ? "Edit Brand" : "Add Brand"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row p-1 g-2">
            <div className="col-md-6">
              <label className="form-label text-dark">Vehicle Type</label>
              <div className="d-flex align-items-center gap-3">
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="vehicleCar"
                    name="vehicleType"
                    checked={!form.is_bike}
                    onChange={() => setForm({ ...form, is_bike: false })}
                  />
                  <label htmlFor="vehicleCar" className="form-check-label">
                    Car
                  </label>
                </div>

                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="vehicleBike"
                    name="vehicleType"
                    checked={form.is_bike}
                    onChange={() => setForm({ ...form, is_bike: true })}
                  />
                  <label htmlFor="vehicleBike" className="form-check-label">
                    Bike
                  </label>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <label className="form-label text-dark">Brand Name</label>
              <input
                type="text"
                className={`form-control ${error?.name ? "is-invalid" : ""}`}
                name="name"
                value={form?.name}
                placeholder="Tata"
                onChange={handleInputChange}
              />
              {error?.name && (
                <small className="text-danger">{error?.name}</small>
              )}
            </div>

            <div className="col-12 mb-4">
              <label className="form-label text-dark">Brand Logo</label>
              <FileUpload
                label="Drag & drop File (max size 3MB)"
                accept=".jpg,.jpeg,.png"
                multiple={false}
                value={form.logo}
                onChange={(files) =>
                  setForm((prev) => ({ ...prev, logo: files }))
                }
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 w-100">
            <span
              className="btn btn-outline-dark"
              disabled={loading}
              onClick={onClose}
            >
              Cancel
            </span>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading && (
                <Spinner
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {data ? "Update" : "Submit"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddBrandModal;
